import { FiChevronLeft } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const MonthEndBonanzaFaq = () => {

    const navigate = useNavigate();

    return (
        <div style={{ padding: '20px', color: '#FFFFFF' }}>
            <div style={{ display: 'flex', alignItems: 'center', marginTop: '30px' }}>
                <button className='back-button' onClick={() => navigate('/home')}>
                    <FiChevronLeft className='back-button-icon' />
                </button>
                <div style={{ color: '#FFFFFF', fontSize: '18px', fontWeight: 700, marginLeft: '20px' }}>FAQ</div>
            </div>
            <div>
                <ul className='mt-4'>
                    <li>
                        <p className='FAQ-Question'>What is Month End Bonanza?</p>
                        <p className='paragraph'>The Month End Bonanza is a limited-time rewards event where you can earn Bitcoin rewards (sats) on every card spend.</p>
                    </li>
                   {/*  <li>
                        <p className='FAQ-Question'>When does the Month End Bonanza start?</p>
                        <p className='paragraph'>The campaign starts on 22nd January, 2026 at 10:30AM.</p>
                    </li> */}
                    {/* <li>
                        <p className='FAQ-Question'>When does the Month End Bonanza end?</p>
                        <p className='paragraph'>The campaign ends on 28th January, 2026 at 11:59PM.</p>
                    </li> */}
                    {/* <li>
                        <p className='FAQ-Question'>How to complete the "Activate your Card" action?</p>
                        <p className='paragraph'>To complete this action, users must purchase a GoSats Card (if not already purchased) and complete the minimum KYC process.</p>
                    </li> */}
                    {/* <li>
                        <p className='FAQ-Question'>What transactions are eligible for the Daily Spend rewards?</p>
                        <p className='paragraph'>Transactions made using Card / Voucher / Card-Voucher are eligible for Daily Spend rewards.</p>
                    </li> */}
                    {/* <li>
                        <p className='FAQ-Question'>Are there any ineligible transaction categories for the 3% rewards on card spends?</p>
                        <p className='paragraph'>Yes. Transactions in the following categories are excluded: Fastag Recharge, Indian Railways, Bill & Utility Payments, Digital Wallet Loads, Real Estate, Government Services, Telecommunications, Insurance, Quasi Cash, Fuel, Rent/Education, Toll & Bridge, Discount Stores, Voucher Purchases, SatsPay, BBPS, and Gold Investments.</p>
                    </li> */}
                    {/* <li>
                        <p className='FAQ-Question'>What if I join the campaign after Day 1?</p>
                        <p className='paragraph'>You can still participate. Rewards will be credited based on the number of eligible days you complete during the campaign period.</p>
                    </li> */}
                    {/* <li>
                        <p className='FAQ-Question'>Is there any additional benefit during this period?</p>
                        <p className='paragraph'>Yes! For the entire month, you earn 3% back on all eligible card spends.</p>
                    </li> */}
                    <li>
                        <p className='FAQ-Question'>The reward structure of the 3% rewards will be as follows:</p>
                        <p className='paragraph'>1% rewards are withdrawable on the Bitcoin blockchain</p>
                        <p className='paragraph'>2% rewards can be used for redemptions within the GoSats app </p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>What are the limits or caps per user on the Rewards?</p>
                        <p className='paragraph'>There is no limit on the Rewards you can earn from the campaign. However, if found to be invalid, duplicate, or suspicious activities, the rewards will be revoked.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>Are there any ineligible transaction categories for the 3% rewards on Elite Card Spends?</p>
                        <p className='paragraph'>Yes, transactions in Fastag Recharge, Indian Railways, Bill/Utility Payments, Digital Wallet Loads, Real Estate, Government services, Telecommunications, Gift, Novelty, and Souvenir Shops, Insurance, Quasi Cash, Fuel, Rent/Education, Toll, Bridge, Discount Stores and card spends on Voucher Purchases, SatsPay, BBPS and Gold Investments are excluded.</p>
                    </li>
                    <li>
                        <p className='FAQ-Question'>What if I don't receive my rewards?</p>
                        <p className='paragraph'>Please contact our in-app support or write to us at "support@gosats.io" from your registered email ID</p>
                    </li>
                </ul>
            </div>
        </div>
    )
}

export default MonthEndBonanzaFaq;